import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ASSETS, BUY_URL, X_URL } from "@/config";
import MobileMenu from "@/components/MobileMenu";

const CENTER_LINKS = [
  { to: "/network", label: "NETWORK" },
  { to: "/agents", label: "AGENTS" },
  { to: "/machines", label: "MACHINES" },
  { to: "/tasks", label: "TASKS" },
  { to: "/economy", label: "ECONOMY" },
  { to: "/terminal", label: "TERMINAL" },
  { to: "/thesis", label: "THESIS" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  return (
    <>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-arc-navy focus:text-arc-cyan focus:px-3 focus:py-2 focus:font-mono focus:text-xs">
        Skip to content
      </a>
      <nav data-testid="navbar" className="fixed top-0 inset-x-0 z-50 bg-arc-black/85 backdrop-blur-md border-b border-arc-blue/15">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/" data-testid="nav-logo" data-cursor="OPEN" className="flex items-center gap-3 shrink-0" aria-label="ARCMECH home">
            <img src={ASSETS.logo} alt="ARCMECH" className="h-9 w-auto" />
          </Link>
          <div className="hidden lg:flex items-center gap-6">
            {CENTER_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase()}-link`}
                data-cursor="OPEN"
                className={({ isActive }) =>
                  `font-mono text-[11px] tracking-[0.25em] transition-colors duration-200 ${
                    isActive ? "text-arc-cyan" : "text-arc-silver/60 hover:text-arc-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
          <div className="hidden lg:flex items-center gap-5">
            <NavLink to="/docs" data-testid="nav-docs-link" data-cursor="OPEN" className={({ isActive }) => `font-mono text-[11px] tracking-[0.25em] ${isActive ? "text-arc-cyan" : "text-arc-silver/60 hover:text-arc-white"}`}>
              DOCS
            </NavLink>
            <a href={X_URL} target="_blank" rel="noopener noreferrer" data-testid="nav-x-link" data-cursor="OPEN" className="font-mono text-[11px] tracking-[0.25em] text-arc-silver/60 hover:text-arc-white" aria-label="ARCMECH on X">
              X
            </a>
            <a
              href={BUY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-buy-button"
              data-cursor="TARGET"
              className="clip-btn btn-scan bg-arc-blue border border-arc-electric/70 text-arc-white font-mono text-[11px] font-semibold tracking-[0.2em] px-5 py-2.5 hover:bg-arc-electric hover:text-arc-black transition-colors duration-300"
            >
              BUY $ARCMECH
            </a>
          </div>
          <button
            data-testid="mobile-menu-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="lg:hidden relative w-11 h-11 hud-panel flex flex-col items-center justify-center gap-1.5"
          >
            <span className={`block w-5 h-px bg-arc-cyan transition-transform duration-300 ${open ? "rotate-45 translate-y-[3.5px]" : ""}`} />
            <span className={`block w-5 h-px bg-arc-cyan transition-opacity duration-300 ${open ? "opacity-0" : ""}`} />
            <span className={`block w-5 h-px bg-arc-cyan transition-transform duration-300 ${open ? "-rotate-45 -translate-y-[3.5px]" : ""}`} />
            <span className="absolute bottom-1 font-mono text-[7px] tracking-[0.2em] text-arc-silver/40">{open ? "CLS" : "SYS"}</span>
          </button>
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-arc-electric/40 to-transparent" aria-hidden="true" />
      </nav>
      <MobileMenu open={open} onClose={() => setOpen(false)} pathname={location.pathname} />
    </>
  );
};

export default Navbar;
